import { createAction, props } from '@ngrx/store';
import { CustomOptions } from './customOptions.model';
import { CustomOptionsApiError } from './customOptions.error';

export const LoadRawSchema = createAction('[CustomOptions] Load Raw Schema');

export const SetRawSchema = createAction(
  '[CustomOptions] Set Raw Schema',
  props<{ payload: any }>(),
);

export const SetLoadRawSchemaError = createAction(
  '[CustomOptions] Set Load Raw Schema Error',
  props<{ payload: Error }>(),
);

export const LoadCustomOptions = createAction(
  '[CustomOptions] Load Customization Options',
  props<{ avatar: string }>(),
);

export const SetCustomOptions = createAction(
  '[CustomOptions] Set Customization Options',
  props<{ options: CustomOptions }>(),
);

export const SetLoadCustomOptionsError = createAction(
  '[CustomOptions] Error Load Customization Options',
  props<{ error: CustomOptionsApiError }>(),
);

export const RemoveCustomOptionsError = createAction(
  '[CustomOptions] Remove Customization Options Error',
);
